import ShowRefinementFilters from './show-refinement-filters';

export default ShowRefinementFilters;
